import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Tab } from '@material-ui/core'
import { TabPanel, TabContext, TabList } from '@material-ui/lab'

import Header from '../../components/Header/Header';
import Title from '../../components/Title/Title';

import Quadros from './Quadros';

import RelatorioService from '../../services/Relatorio';

import Layout from '../../layouts/public/Public';

import useStyles from './Style';

const EmNumeros = () => {
    const classes = useStyles();

    const [tab, setTab] = useState("3");

    const handleChange = (e, newTab) => {
        setTab(newTab);
    };

    return (
        <Layout>
            <Header />
            
            <Container maxWidth="xl" className={classes.container} >
                <Grid container spacing={8} >
                    <Grid item xs={12} sm={12} lg={12} xl={12} >
                        <Title variant="h4">
                            Mirim em Números
                        </Title>
                    </Grid>
                </Grid>

                <Grid item xs={12} >
                    <Paper style={{ padding: '24px' }} elevation={2}>
                        <TabContext value={tab}>
                            <TabList onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
                                <Tab label="3ª Olimpíada Mirim" value="3" />
                                <Tab label="2ª Olimpíada Mirim" value="2" />
                                <Tab label="1ª Olimpíada Mirim" value="1" />
                            </TabList>

                            <TabPanel value="3">
                                <Quadros report={() => RelatorioService.reportNumbersGeneralsPublicFromEdition("3")} />
                            </TabPanel>
                            <TabPanel value="2">
                                <Quadros report={() => RelatorioService.reportNumbersGeneralsPublicFromEdition("2")} />
                            </TabPanel>
                            <TabPanel value="1">
                                <Quadros report={() => RelatorioService.reportNumbersGeneralsPublicFromEdition("1")} mostrarPrivadas={false} />
                            </TabPanel>
                        </TabContext>
                    </Paper>
                </Grid>
            </Container>
        </Layout>
    )
}

export default EmNumeros;